// Module
var code = "<div class=\"at-least-full-screen\"> <div class=\"container-centering-vertical-flex d-flex align-items-center h-100\" id=\"main\"> <div style=\"width:100%;max-width:600px;margin:auto\" class=\"align-self-center\"> <fdx-redirect></fdx-redirect> </div> </div> </div> ";
// Exports
module.exports = code;